import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-auction-hammer',
  templateUrl: './auction-hammer.component.html'
})
export class AuctionHammerComponent implements OnInit {

  @Input() timeToOpen: string;
  @Input() priceTheory: Number;
  @Input() varTheory: Number;

  constructor() {
  }

  ngOnInit() {
  }

}
